import { useEffect, useRef, useState } from "react";

const STATIC_OFFSET = 100;
const HEIGHT_DIVIDER = 0.68;

export const useSearchBarIsVisible = () => {
  const [elementIsVisible, setElementIsVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const isElementInViewport = (container) => {
      if (!container) return false;

      const rect = container.getBoundingClientRect();
      const topOffset = rect.height * HEIGHT_DIVIDER - STATIC_OFFSET;

      return (
        rect.top + topOffset >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= window.innerHeight &&
        rect.right <= window.innerWidth
      );
    };

    const handleScroll = () => {
      setElementIsVisible(isElementInViewport(containerRef.current));
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return { elementIsVisible, containerRef };
};
